type MultipartRecoveryOptions<T> = {
    workers: Promise<void>[]
    complete: (recovering: boolean) => Promise<T>
    abort: () => Promise<void>
    isRecoverableFailure: (error: unknown) => boolean
}

export async function completeMultipartAfterWorkers<T>({
    workers,
    complete,
    abort,
    isRecoverableFailure,
}: MultipartRecoveryOptions<T>): Promise<T> {
    const results = await Promise.allSettled(workers)
    const workerFailures = results.filter(
        (result): result is PromiseRejectedResult => result.status === 'rejected',
    )

    if (!workerFailures.length) return complete(false)

    const nonRecoverableFailure = workerFailures.find(
        failure => !isRecoverableFailure(failure.reason),
    )
    if (nonRecoverableFailure) {
        try {
            await abort()
        } catch {}
        throw nonRecoverableFailure.reason
    }

    try {
        // A browser-level network error does not prove the PUT failed. S3's
        // authoritative parts list decides whether this upload can be completed.
        return await complete(true)
    } catch {
        try {
            await abort()
        } catch {}
        throw workerFailures[0].reason
    }
}
